import {PPResponse} from '@gongxigames/framework/integrations/pariplay/response/PPResponse';
import {PPConfiguration} from '@gongxigames/framework/integrations/pariplay/PPConfiguration';
import {ServerMessage} from '@gongxigames/framework/slot';

export class PPPlaceBetResponse extends PPResponse {
    public getBalance(): number {
        return PPConfiguration.convertDoubleToInt(this.source.Balance.BalanceAfter);
    }

    public getTicketID(): number {
        if (this.source && this.source.Ticket) {
            return this.source.Ticket.Id;
        } else {
            return -1;
        }
    }

    public getMessages(): ServerMessage[] {
        const msg = new ServerMessage();

        msg.topic = ServerMessage.TOPIC_POPUP;
        msg.data = [];

        if (this.source.Message) {
            for (const message of this.source.Message) {
                msg.data.push(message);
            }
        }

        return [msg];
    }

    public getRPBody(): any {
        const res: any = {};

        res.data = JSON.parse(this.source.Ticket.GameClientState);

        return res;
    }
}
